var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeletestrokeHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 5.63828C2.75 5.10671 3.18093 4.67578 3.7125 4.67578H18.2875C18.8191 4.67578 19.25 5.10671 19.25 5.63828C19.25 6.16986 18.8191 6.60078 18.2875 6.60078V18.9758C18.2875 19.6592 17.7335 20.2133 17.05 20.2133H4.95C4.26655 20.2133 3.7125 19.6592 3.7125 18.9758V6.60078C3.18093 6.60078 2.75 6.16986 2.75 5.63828ZM5.6375 6.60078V18.2883H16.3625V6.60078H5.6375Z",
    fill: "#D92828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.21211 3.71211V4.67461H7.28711V3.02461C7.28711 2.34116 7.84116 1.78711 8.52461 1.78711H13.4746C14.1581 1.78711 14.7121 2.34116 14.7121 3.02461V4.67461H12.7871V3.71211H9.21211Z",
    fill: "#D92828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07578 8.25C9.60736 8.25 10.0383 8.68093 10.0383 9.2125V15.8125C10.0383 16.3441 9.60736 16.775 9.07578 16.775C8.54421 16.775 8.11328 16.3441 8.11328 15.8125V9.2125C8.11328 8.68093 8.54421 8.25 9.07578 8.25Z",
    fill: "#D92828"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9254 8.25C13.457 8.25 13.8879 8.68093 13.8879 9.2125V15.8125C13.8879 16.3441 13.457 16.775 12.9254 16.775C12.3938 16.775 11.9629 16.3441 11.9629 15.8125V9.2125C11.9629 8.68093 12.3938 8.25 12.9254 8.25Z",
    fill: "#D92828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletestrokeHover);
export default __webpack_public_path__ + "static/media/Delete(stroke)_hover.213595cdc4cdd918bc9ae09a5d17a252.svg";
export { ForwardRef as ReactComponent };